import { html, LitElement, svg } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./question-slide.css";

import type { SlideViewMode } from "../slide/slide";

// TODO support more icons/intents
const icon = svg`<svg class="icon" aria-hidden="true" focusable="false" role="img" viewBox="0 0 512 512" style="--icon-color:var(--color-white); --icon-size:var(--size-6);"><path d="M448 0H64C28.63 0 0 28.62 0 63.1v287.1C0 387.4 28.63 415.1 64 415.1h96v83.1c0 9.873 11.25 15.52 19.12 9.649L304 415.1H448c35.38 0 64-28.63 64-63.1V63.1C512 28.62 483.4 0 448 0zM249.1 320C235.4 320 224 308.6 224 294S235.4 268 249.1 268C264.6 268 276 279.4 276 294S264.6 320 249.1 320zM307.7 203.4l-38.33 23.13v1.652c0 10.74-9.168 19.83-20 19.83c-10.83 0-20-9.088-20-19.83V214.1c0-6.609 3.332-13.22 10-17.35l47.5-28.09C292.7 166.2 296 160.4 296 153.8c0-9.914-8.334-18.17-18.33-18.17H234.3c-10 0-18.33 8.26-18.33 18.17c0 10.74-9.166 19.83-20 19.83S176 164.6 176 153.8C176 121.6 201.8 96 234.3 96h43.33C310.2 96 336 121.6 336 153.8C336 173.7 325.2 192.7 307.7 203.4z"/></path></svg>`;

@customElement("bp-question-slide")
export class QuestionSlide extends LitElement {
  static styles = styles;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    return html`
      <div class="question-slide ${this.viewMode}">
        <div class="content-container">
          <div class="content">
            <div class="icon-container">${icon}</div>
            <slot></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-question-slide": QuestionSlide;
  }
}
